import type { StoreState } from 'src/store/types';

export const selectHasAnalyticsTimedOut = (state: StoreState) =>
  state.hasAnalyticsTimedOut;

export const selectFeatures = (state: StoreState) => state.features;
